import React, { useContext } from 'react';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';
import RedDelete from "../../../Assets/redDelete.svg";
import { getCachedMediaUrl } from '../../../lib/utils/utils';

function SelectedProducts() {
    const { selectedProducts, setSelectedProducts, setSelectionType } = useContext(AddCouponFormContext);

    const handleRemoveProducts = () => {
        setSelectionType('');
        setSelectedProducts([]);
    }

    const handleRemoveProduct = (product) => {
        if(selectedProducts?.length === 1) {
            setSelectionType('');
            setSelectedProducts([]);
            return;
        }
        const filteredList = selectedProducts.filter(item => item.product.id !== product.product.id);
        setSelectedProducts(filteredList);
    }

    return (
        <div className="border border-[#EAEAEA] rounded-xl p-5 flex flex-col gap-3">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Products</h1>
            
                <button onClick={handleRemoveProducts} className='font-inter font-medium text-[16px] leading-5 text-[#EF4444]'>Remove</button>
            </div>

            <div className="border border-[#EAEAEA] rounded-lg overflow-hidden">
                <h1 className='bg-[#F5F5F5] px-[10px] py-2 font-semibold text-base text-[#121212]'>Product name</h1>

                {
                    selectedProducts?.map(product => {
                        return (
                            <div key={product.product.id} className="px-[10px] py-2 flex items-center gap-1">
                                <div className="size-14 flex items-center justify-center rounded-lg overflow-hidden">
                                    <img className='size-full object-cover' src={getCachedMediaUrl(product.product.productImgUrls[0])} alt="" />
                                </div>

                                <p className="w-[calc(100%-56px-44px)] font-medium text-[14px] leading-6 text-[#121212] whitespace-nowrap overflow-hidden text-ellipsis">{product.product.productName}</p>

                                <button onClick={() => handleRemoveProduct(product)} className="size-11 flex items-center justify-center outline-none">
                                    <img src={RedDelete} alt="" />
                                </button>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default SelectedProducts;
